import * as THREE from 'three';
import { AU, boom } from './audio';
import { _eyeL, _eyeR, beamGlow, cyl, hitPoint, placeBeam, scorch } from './beam';
import { damage, destroyBuilding } from './destruction';
import { buildings, debris } from './entities';
import { toast } from './hud';
import { dust, sparks } from './particles';
import { camera, ground, renderer, rig, scene } from './scene';
import { S } from './state';
import { killCarsNear } from './traffic';
import { $, lerp, rnd } from './util';

export const ringGeo = new THREE.RingGeometry(0.9, 1, 48); export const ringMat = new THREE.MeshBasicMaterial({color:new THREE.Color(3,2,0.8), transparent:true, opacity:.8, side:THREE.DoubleSide, depthWrite:false, blending:THREE.AdditiveBlending, fog:false});
export const rings = [];
export function shockRing(p, r0, r1, life){ const m = new THREE.Mesh(ringGeo, ringMat.clone()); m.rotation.x = -Math.PI/2; m.position.set(p.x, groundAt(p.x, p.z, 0) + 1.2, p.z); scene.add(m); rings.push({m, r0, r1, t:0, life}); }
export function updateRings(dt){ for (let i=rings.length-1;i>=0;i--){ const r = rings[i]; r.t += dt; const k = r.t/r.life; if (k>=1){ scene.remove(r.m); r.m.material.dispose(); rings.splice(i,1); continue; } const rad = lerp(r.r0, r.r1, 1-Math.pow(1-k,2)); r.m.scale.set(rad,rad,1); r.m.material.opacity = 0.8*(1-k); } }
export function movesUI(){
  const el = $('#hammerui'); if (!el) return;
  if (S.hammer) el.innerHTML = '<b>HAMMER</b> · incoming'; else if (S.hammerCd <= 0) el.innerHTML = '<b>HAMMER</b> · ✊ or <kbd>1</kbd> · ready'; else el.innerHTML = `HAMMER · ${Math.ceil(S.hammerCd)}s`;
  el.classList.toggle('ready', !S.hammer && S.hammerCd <= 0);
}
export function roar(){
  if (S.roarCd > 0) return; S.roarCd = 8; S.specials++;
  const p = new THREE.Vector3(rig.base.x, 0, rig.base.z);
  shockRing(p, 10, 110, 0.9); rig.shake += 2.2; boom(0.7); toast('ROAR');
  $('#shockring').style.opacity = 1; setTimeout(()=>$('#shockring').style.opacity = 0, 250);
  killCarsNear(p.x, p.z, 90, 40);
  for (let i=buildings.length-1;i>=0;i--){ const b = buildings[i], u = b.userData; const d = Math.hypot(u.center.x-p.x, u.center.z-p.z) - u.fr;
    if (d < 80 && u.h < 26) destroyBuilding(b, p, true); else if (d < 120) damage(b, 0.25, performance.now()); }
  for (const h of S.helis){ const d = h.g.position.distanceTo(camera.position); if (d < 320){ h.hp -= 0.5; h.r += 90; h.shootT += 3; } }
  for (const d of debris){ const dx = d.body.position.x-p.x, dz = d.body.position.z-p.z; const L = Math.hypot(dx,dz)||1; if (L < 120){ d.body.wakeUp(); d.body.velocity.x += dx/L*30; d.body.velocity.z += dz/L*30; d.body.velocity.y += 14; } }
  for (let i=0;i<120;i++) dust.emit(new THREE.Vector3(p.x+rnd(-30,30), 2, p.z+rnd(-30,30)), new THREE.Vector3(rnd(-1,1)*20, 8, rnd(-1,1)*20), 10, 2.5);
}
export function hammer(){
  if (S.hammer || S.hammerCd > 0) return; S.hammerCd = S.mode==='world' ? 20 : 15; S.specials++;
  S.hammer = {t:0, p:hitPoint.clone()}; toast('HAMMER', 'incoming');
  if (AU.ctx){ const t = AU.ctx.currentTime; const o = AU.ctx.createOscillator(); o.type='sine'; o.frequency.setValueAtTime(90,t); o.frequency.exponentialRampToValueAtTime(30,t+1); const g = AU.ctx.createGain(); g.gain.setValueAtTime(0.4,t); g.gain.exponentialRampToValueAtTime(0.001,t+1.05); o.connect(g); g.connect(AU.master); o.start(t); o.stop(t+1.1); }
}
export function hammerLand(){
  const p = S.hammer.p; S.hammer = null; if (mpHooks.hammer) mpHooks.hammer(p);
  shockRing(p, 5, 160, 1.1); shockRing(p, 5, 70, 0.6); rig.shake += 6; boom(1);
  $('#shockring').style.opacity = 1; setTimeout(()=>$('#shockring').style.opacity = 0, 400);
  scorch(p, 40); killCarsNear(p.x, p.z, 120, 60);
  for (let i=buildings.length-1;i>=0;i--){ const b = buildings[i], u = b.userData; const d = Math.hypot(u.center.x-p.x, u.center.z-p.z) - u.fr;
    if (mpHooks.hammer) continue;
    if (d < 70) destroyBuilding(b, p, false); else if (d < 140) damage(b, u.maxHp*0.6*(1-(d-70)/70), performance.now()); }
  for (const h of S.helis){ if (h.g.position.distanceTo(p) < 180) h.hp -= 1.5; }
  for (let i=0;i<300;i++) dust.emit(new THREE.Vector3(p.x+rnd(-50,50), 2, p.z+rnd(-50,50)), new THREE.Vector3(rnd(-1,1)*30, 14, rnd(-1,1)*30), 12, 4);
  for (let i=0;i<120;i++) sparks.emit(p, new THREE.Vector3(0,30,0), 60, 1);
}
export function prism(){}
export function shield(){}
export const shieldMesh = new THREE.Mesh(new THREE.SphereGeometry(1, 24, 16), new THREE.MeshBasicMaterial({color:new THREE.Color(0.5,1.2,2.2), transparent:true, opacity:.12, side:THREE.BackSide, depthWrite:false, blending:THREE.AdditiveBlending, fog:false})); shieldMesh.visible = false; scene.add(shieldMesh);
// extra beams for prism
export const prismBeams = []; for (let i=0;i<4;i++){ const m = new THREE.Mesh(cyl, beamGlow[0].material); m.visible = false; scene.add(m); prismBeams.push(m); }
export const prismRay = new THREE.Raycaster(); prismRay.far = 3000; export const _pp = new THREE.Vector3();
export function updateSpecials(dt, now){
  S.hammerCd = Math.max(0, S.hammerCd - dt);
  // fist held 0.5s → hammer, once per hold
  if (!S.keyboard && S.gesture==='Closed_Fist' && !S.gestureFired && now - S.gestureT > 500){ S.gestureFired = true; hammer(); }
  const gEl = $('#gesture'); const gname = S.gesture==='Closed_Fist' ? '✊ hammer' : '';
  gEl.textContent = gname || ''; gEl.classList.toggle('on', !!gname);
  if (S.hammer){ S.hammer.t += dt; rig.shake = Math.max(rig.shake, 0.6 + S.hammer.t); renderer.toneMappingExposure *= 0.985; if (S.hammer.t >= 1) hammerLand(); }
  shieldMesh.visible = S.shieldT > 0; if (shieldMesh.visible){ shieldMesh.position.copy(camera.position); shieldMesh.scale.setScalar(14 + Math.sin(now/120)*0.4); shieldMesh.material.opacity = 0.08 + 0.05*Math.min(1, S.shieldT); }
  // prism: two side beams
  const showP = S.prismT > 0 && S.firing;
  for (const m of prismBeams) m.visible = showP;
  if (showP){
    const w = (0.4 + 3*S.width);
    for (let k=0;k<2;k++){ const side = k===0 ? -1 : 1;
      prismRay.setFromCamera({x:(S.aim.x*2-1) + side*0.22, y:-(S.aim.y*2-1) + 0.02} as any, camera);
      const hits = prismRay.intersectObjects(buildings, false); let tgt = null;
      if (hits.length){ tgt = hits[0].object; _pp.copy(hits[0].point); } else { const g = prismRay.intersectObject(ground, false); if (g.length) _pp.copy(g[0].point); else _pp.copy(prismRay.ray.at(2500, _pp)); }
      placeBeam(prismBeams[k*2], prismBeams[k*2+1], k===0 ? _eyeL : _eyeR, _pp, w);
      if (tgt) damage(tgt, (0.8 + 1.5*S.width)*dt, now);
      for (let i=0;i<2;i++) sparks.emit(_pp, new THREE.Vector3(0,12,0), 20, 0.4);
      killCarsNear(_pp.x, _pp.z, 5 + 10*S.width, 24);
    }
  }
  updateRings(dt); movesUI();
}

import { mpHooks } from './destruction';
import { groundAt } from '../world/tiles';
